export default function useQuizSerializer(Serializer) {
  Serializer.addProperty('question', { category: 'general', name: 'id:text', readOnly: true });
  (Serializer.findProperty('question', 'id') || {}).visible = true;

  Serializer.findProperty('question', 'visible').displayName = 'Show question'; // change "is visible?" to "show question"
  Serializer.findProperty('question', 'isRequired').displayName = 'Must answer'; // change "is required?" to "must answer"
}
